import styled from "@emotion/styled"

export const PagerWrap = styled.ul`
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 0;

  li {
    .Tertiary {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .left-arrow {
    transform: rotate(180deg);
  }

  .textelement.nova {
    line-height: 24px !important;
  }

  button:hover {
  }
`
